import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import loadingSpinner from 'img/spinner.gif'

const styles = theme => ({
  loadingPlaceholder: {
    color: theme.palette.text.primary
  },
  loadingSpinner: {
    backgroundImage: `url(${loadingSpinner})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    backgroundSize: 'contain',
    marginRight: '5px',
    width: '20px',
    height: '20px',
    float: 'left'
  },
  loadingText: {
    verticalAlign: 'text-top'
  }
})

class Loading extends React.PureComponent {
  render () {
    const { classes, text } = this.props

    // Note: no text will be shown when text = '' (empty string)
    const loadingText = (typeof text === 'undefined') ? 'Loading, please wait...' : text

    return (
      <div className={classes.loadingPlaceholder}>
        <span className={classes.loadingSpinner}></span>
        <span className={classes.loadingText}>{loadingText}</span>
      </div>
    )
  }
}

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string
}

export default (
  withStyles(styles)(Loading)
)
